// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import axios from 'axios'

import {APIUrl, APIHeaders} from './utils'
import {SSI_API} from '../config'
import {unexpectedApiError} from './apiErrors'
import {showComponentSpinner, ON_FETCH} from './spinner'
import {errorToast} from './toastMessages'

export const FETCH_DEVICES = 'fetch_devices'
export const FETCH_HOSTS = 'fetch_hosts'
export const FETCH_STATE = 'fetch_state'
export const FETCH_SYSTEM = 'fetch_system'
export const FETCH_CLIENT_ACTIVITY = 'fetch_client_activity'
export const SET_REFRESH_DATE = 'set_refresh_date'

export function fetchMultiDRMData () {
  // This method is for unifying all the fetch methods from MultiDRM table into one to show the component spinner
  // All the error logic hanling is being done in each method, so this one is dummy
  return (dispatch) => {
    let date = new Date()
    dispatch(showComponentSpinner(true, ON_FETCH))
    Promise.all(
      [
        dispatch(fetchHosts()),
        dispatch(fetchState()),
        dispatch(fetchDevices()),
        dispatch(fetchActivity()),
      ]
    ).then(() => {
      dispatch(showComponentSpinner(false))
      dispatch({
        type: SET_REFRESH_DATE,
        payload: date
      })
    }).catch(error => {
      dispatch(showComponentSpinner(false))
      dispatch({
        type: SET_REFRESH_DATE,
        payload: date
      })
      if (error.response) {
        if (error.response.data && error.response.data.code !== 'STAT-111') {
          // STAT-111 means No devices error
          dispatch(errorToast(error.response.data.message))
        }
      } else {
        unexpectedApiError()
      }
    })
  }
}

export function fetchDevices () {
  return (dispatch, getState) => {
    const {session} = getState()
    return axios.get(APIUrl(`devices/`, {}, SSI_API), {headers: APIHeaders(session)}).then(data => {
      dispatch({
        type: FETCH_DEVICES,
        payload: {
          devices: data.data
        }
      })
    }).catch( error => {
      // The API returns 404 if there is no device for all products
      if (error.request.status === 404) {
        dispatch({
          type: FETCH_DEVICES,
          payload: {
            devices: {}
          }
        })
      }
    })
  }
}

export function fetchHosts () {
  return (dispatch, getState) => {
    const {session} = getState()
    return axios.get(APIUrl('hosts/', {}, SSI_API), {headers: APIHeaders(session)}).then(data => {
      const {hosts} = data.data
      dispatch({
        type: FETCH_HOSTS,
        payload: {
          hosts: hosts
        }
      })
      return dispatch(fetchSystem())
    })
  }
}

export function fetchState () {
  return (dispatch, getState) => {
    const {session} = getState()
    return axios.get(APIUrl(`products/state/`, {}, SSI_API), {headers: APIHeaders(session)}).then(data => {
      dispatch({
        type: FETCH_STATE,
        payload: {
          state: data.data
        }
      })
    })
  }
}

export function fetchSystem () {
  return (dispatch, getState) => {
    const {session} = getState()
    const {multiDRM} = getState()
    const {hosts} = multiDRM

    return axios.get(APIUrl(`hosts/system/${hosts[0]}`, {}, SSI_API), {headers: APIHeaders(session)}).then(data => {
      dispatch({
        type: FETCH_SYSTEM,
        payload: {
          system: data.data
        }
      })
    }).catch(() => {
      dispatch(unexpectedApiError())
    })
  }
}

export function fetchActivity () {
  return (dispatch, getState) => {
    const {session} = getState()

    const url = APIUrl('events/usage/latest/', {}, SSI_API)

    return axios.get(url, {headers: APIHeaders(session)}).then(data => {

      dispatch({
        type: FETCH_CLIENT_ACTIVITY,
        payload: {
          activity: data.data
        }
      })
    }).catch(() => {
      dispatch(unexpectedApiError())
    })
  }
}
